export default __webpack_public_path__ + "static/banner_1_2-4727729335e60f9cb8b3fa081bdac800.jpg";